import {
  AppEmbedData,
  AudioData,
  ButtonData,
  CollapsibleListData,
  DividerData,
  EmbedData,
  FileData,
  GalleryData,
  GIFData,
  HTMLData,
  ImageData,
  LinkPreviewData,
  PollData,
  TableData,
  VideoData
} from "./../../../../ricos-schema/legacy/wix/rich_content/v1";
import {
  ACTION_BUTTON_TYPE,
  APP_EMBED_TYPE,
  AUDIO_TYPE,
  COLLAPSIBLE_LIST_TYPE,
  DIVIDER_TYPE,
  EMBED_TYPE,
  EXTERNAL,
  FILE_UPLOAD_TYPE,
  GALLERY_TYPE,
  GIPHY_TYPE,
  HTML_TYPE,
  IMAGE_TYPE,
  IMAGE_TYPE_LEGACY,
  LINK_BUTTON_TYPE,
  LINK_PREVIEW_TYPE,
  POLL_TYPE,
  TABLE_TYPE,
  VIDEO_TYPE,
  VIDEO_TYPE_LEGACY
} from "../../../consts";
const TO_RICOS_DATA = {
  [LINK_BUTTON_TYPE]: ButtonData,
  [ACTION_BUTTON_TYPE]: ButtonData,
  [DIVIDER_TYPE]: DividerData,
  [FILE_UPLOAD_TYPE]: FileData,
  [GALLERY_TYPE]: GalleryData,
  [GIPHY_TYPE]: GIFData,
  [HTML_TYPE]: HTMLData,
  [IMAGE_TYPE]: ImageData,
  [IMAGE_TYPE_LEGACY]: ImageData,
  [LINK_PREVIEW_TYPE]: LinkPreviewData,
  [APP_EMBED_TYPE]: AppEmbedData,
  [VIDEO_TYPE]: VideoData,
  [VIDEO_TYPE_LEGACY]: VideoData,
  [AUDIO_TYPE]: AudioData,
  [POLL_TYPE]: PollData,
  [EMBED_TYPE]: EmbedData,
  [COLLAPSIBLE_LIST_TYPE]: CollapsibleListData,
  [TABLE_TYPE]: TableData,
  [EXTERNAL]: {
    fromJSON(data) {
      return data;
    }
  }
};
export {
  TO_RICOS_DATA
};
//# sourceMappingURL=consts.js.map
